require('frontend-controller/client/run')(
    require('./clientAppConfig'),
    {
        templates:      require.context('./components/', true, /^\.\/.*\.ejs$/),
        components:     require.context('./components/', true, /^\.\/.*\.js$/),
        styles:         require.context('./components/', true, /^\.\/.*\.less$/),
        translations:   require.context('./i18next/', true, /^\.\/.*\.js$/),
    },
    () => {
        // init vendors
        require('gsap/TweenMax')
        require('gsap/Draggable')
        require('./vendor/ckeditor/index')
        require('normalize.css')
        require('jstree')
        require('jstree/src/misc') // needed for node_customize plugin
        require('jstree/dist/themes/default/style.css')
        require('frontend-controller/vendors/flag-icons.less')

        // init custom styles
        require('./styles/index.less')
    }
)
